import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Alert, Button, Card, Col, Form, Icon, Input, Row, Typography } from 'antd';

import { requestPasswordReset } from '../../redux/auth';

const ForgotPassword = ({ requestPasswordReset }) => {
  const [form] = Form.useForm();
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const onFinish = async (values) => {
    setLoading(true);
    const ok = await requestPasswordReset(values.email);
    setLoading(false);
    setSubmitted(!!ok);
  };

  if (submitted) {
    return (
      <Row style={{ paddingTop: 200 }}>
        <Col span={6} offset={9}>
          <Card bordered={false} style={{ borderRadius: 8, textAlign: 'center', paddingTop: 8 }}>
            <Icon
              name={'MailOutlined'}
              style={{ fontSize: 48, marginBottom: 12, color: '#1890ff' }}
            />
            <Typography.Title level={3} style={{ marginBottom: 8 }}>
              Письмо отправлено
            </Typography.Title>
            <Typography.Paragraph type="secondary" style={{ marginBottom: 16 }}>
              Проверьте почту и следуйте инструкции для сброса пароля. Если письма нет — посмотрите
              «Спам».
            </Typography.Paragraph>
            <Alert
              type="success"
              message="Ссылка для сброса отправлена на ваш e-mail"
              showIcon
              style={{ textAlign: 'left', marginBottom: 16 }}
            />
            <Button
              type="primary"
              size="large"
              block
              onClick={() => (window.location.href = '/signin')}
            >
              Перейти ко входу
            </Button>
          </Card>
        </Col>
      </Row>
    );
  }

  return (
    <Row style={{ paddingTop: 200 }}>
      <Col span={6} offset={9}>
        <Card>
          <div style={{ textAlign: 'center', marginBottom: 16 }}>
            <Typography.Title level={3} style={{ marginBottom: 0, color: '#fff' }}>
              Восстановление доступа
            </Typography.Title>
            <Typography.Text type="secondary" style={{ marginBottom: 0, color: '#fff' }}>
              Укажите почту — отправим ссылку для сброса пароля
            </Typography.Text>
          </div>

          <Form form={form} onFinish={onFinish} layout="vertical">
            <Form.Item
              name="email"
              label="E-mail"
              rules={[
                { required: true, message: 'Введите e-mail' },
                { type: 'email', message: 'Некорректный e-mail' },
              ]}
            >
              <Input
                size="large"
                placeholder="example@domain.com"
                autoComplete="email"
                prefix={
                  <Icon
                    type={'MailOutlined'}
                    style={{ fontSize: 48, marginBottom: 12, color: '#1890ff' }}
                  />
                }
              />
            </Form.Item>

            <Button type="primary" htmlType="submit" size="large" block loading={loading}>
              Отправить ссылку
            </Button>

            <Button
              style={{ marginTop: 8 }}
              size="large"
              block
              onClick={() => (window.location.href = '/signin')}
            >
              Вернуться ко входу
            </Button>
          </Form>
        </Card>
      </Col>
    </Row>
  );
};

export default connect(null, { requestPasswordReset })(ForgotPassword);
